<template>
    <v-container grid-list-md fluid class="pb-0 mb-0">
        <v-card class="default_card large mx-0 my- fill-height" elevation="0">
            <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-start align-center">
                    <v-btn-back @click="back()"> </v-btn-back>
                    <h1 class="ml-2">Plan Comptable</h1>
                </v-col>
                <v-spacer> </v-spacer>
                <v-col cols="2" class="d-flex align-center justify-end">
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2"
                        :disabled="isDisabled"
                        :loading="importLoading"
                        @click="upsertAccountingPlan()"
                    >
                        Enregistrer
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <div :style="'max-height:' + maxHeight + ';' + 'overflow:auto'">
            <AccountingPlanEditor
                ref="editor"
                @onValidChanged="onValidChanged"
                @setScope="toSetScope"
                @scopeReadonly="setReadonly"
            />

            <ScopeManager
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :hideCompany="true"
                :readonly="readonly"
            />
        </div>
        <!-- <v-tabs
            v-model="activeTab"
            fixed-tabs
            style="border-radius: 12px; overflow: hidden"
            class="bg-white"
        >
            <v-tab value="content" href="#content"> <strong>Plan comptable</strong></v-tab>
            <v-tab value="scope" href="#scope"> <strong>Pour qui ?</strong></v-tab>
        </v-tabs>
        <v-tabs-window v-model="activeTab">
            <v-tabs-window-item value="content" class="pt-4">
                <AccountingPlanEditor
                    ref="editor"
                    @onValidChanged="onValidChanged"
                    @setScope="toSetScope"
                />
            </v-tabs-window-item>
            <v-tabs-window-item value="scope" class="pt-2" :eager="true">
                <v-card class="default_card mx-0 my-2 pa-2" elevation="0">
                    <ScopeManager
                        v-model="scopeSync"
                        v-model:id="scopeId"
                        v-model:name="scopeName"
                        :hideCompany="true"
                        :readonly="readonly"
                    />
                </v-card>
            </v-tabs-window-item>
        </v-tabs-window> -->
    </v-container>
</template>

<script lang="ts">
import { User } from "../../store/store";

import { Component, Hook, Model, Vue, toNative, Ref } from "vue-facing-decorator";
import ScopeManager from "../companyScope/ScopeManager.vue";
import AccountingPlanEditorComp from "./AccountingPlanEditor.vue";

@Component({
    components: {
        AccountingPlanEditor: AccountingPlanEditorComp,
        ScopeManager,
    },
})
export class AccountingPlanStandardEditor extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;
    @Ref() readonly editor!: any;

    @Hook
    beforeRouteLeave(to, from, next) {
        if (this.$store?.state?.importPlanData) {
            // console.log("Deleted imported plan data")
            this.$store.commit("updateImportPlanData", null);
        }
        next();
    }

    selected = [];

    activeTab: string = "content";

    importLoading = false;

    readonly = false;

    get isDisabled() {
        if (!this.isPlanValid) {
            return true;
        }
        if (this.editor?.readonly) {
            return true;
        }
        if (!this.scopeId) {
            return true;
        }
        return false;
    }

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (190 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    isPlanValid: boolean = false;

    onValidChanged(data) {
        this.isPlanValid = data;
    }

    back() {
        this.$router.push({ name: "accounting-plans" });
    }

    // get editor(): AccountingPlanEditor {
    //     return this.$refs.editor as AccountingPlanEditor;
    // }

    toSetScope(scope) {
        this.scopeId = scope?.id;
        this.scopeName = scope?.name;
    }

    setReadonly(readonly) {
        this.readonly = readonly
    }

    async upsertAccountingPlan() {
        if (this.isPlanValid && this.editor) {
            this.importLoading = true;
            const result = await this.editor.upsertAccountingPlan(this.scopeId);
            if (result) {
                this.importLoading = false;
                this.back();
            }
        }
    }
}

export default toNative(AccountingPlanStandardEditor);
</script>
